<template>
    <div class="container-fluid layout-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header admin-header">
                        <h3 class="text-accent-light">خطاهای سامانه</h3>
                    </div>
                    <!--<div>-->
                        <!--<small class="d-inline-block text-center">برای مشاهده متن کامل پیام، روی آن کلیک کنید</small>-->
                    <!--</div>-->

                    <div class="table-responsive">
                        <h6 class="text-center mt-5">لطفا پس از رفع خطاهای یاد شده و اصلاح فاکتور، مجددا فاکتور را به سامانه مالیاتی ارسال نمایید</h6>
                        <table class="table table-hover table-striped">
                            <thead>
                            <tr>
                                <th class=" text-nowrap">کد خطا</th>
                                <th class="text-center text-nowrap">متن خطا</th>
                                <th class="text-center text-nowrap">نوع خطا</th>
                            </tr>
                            </thead>
                            <tbody v-if="errorDatas !== undefined">
                            <tr v-for="(item,index) in errorDatas">
                                <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                <td>{{item.code}}</td>
                                <td class="text-center">{{item.message}}</td>
                                <td class="text-center">{{item.isWarning ?
                                    "اخطار-Warning"
                                    :
                                    "خطا-Error"
                                    }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="w-100 p-3 text-center">
                            <button class="btn btn-info" @click="returnClicked">بازگشت</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";

    export default {
        name: "messages",
        components: {},
        data() {
            return {
                errorDatas:[],
                path:"",
                isLoading: false,
                types: [{
                    id: 5,
                    name: "وام عادی"
                }],
                opType: [
                    {
                        id: 0,
                        name: "پرداختها"
                    },
                    {
                        id: 1,
                        name: "دریافتها"
                    },
                    {
                        id: 2,
                        name: "پرداختها و دریافتها"
                    },

                ],
                messages: [],


                reportModel: {
                    fromDate: "",
                    toDate: "",
                    type: 0,
                    isDebtor: null
                },
                fromDate: "",
                toDate: "",
                send_status: 0,
                show_status: 0,
            }
        },
        mounted() {
            console.log(this.$route.params.errorData)
           this.errorDatas = this.$route.params.errorData;
           this.path = this.$route.params.path;
        },
        methods: {
            returnClicked(){
                this.$router.push({
                    name: this.path,
                });
            },
            onErrorDataClicked(referenceNumber) {
                new BaseService('TaxService', `/GetErrorData/${referenceNumber}`).getList().then(response => {
                    this.errorDatas = response.data.value;
                    if (this.errorDatas !== null && this.errorDatas.length > 0) {

                    } else {
                        this.$noty.success("خطایی یافت نشد، مجددا بروز رسانی فرمائید");
                    }
                }).catch(error => {
                    // error
                    console.log(error.message)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },

        }
    }
</script>

<style lang="scss" scoped>
    .payment-options-container {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        margin-top: 1.5rem;
    }

    .payment-option {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: #ffffff;
        border-radius: 0.25rem;
        padding: 0.5rem;
        box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.5);
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.3s;
    }

    .payment-option.active {
        border: 2px solid #40c4ff;
        box-shadow: 0 5px 15px -2px #40c4ff;
    }

    .payment-option img {
        max-width: 100px;
    }

    .payment-option small {
        color: #333333;
        margin-top: 0.5rem;
    }

    .wallet-payment-wrapper {
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>